<template>
  <div class="m-page">
    <div class="m-box">
      <v-radio v-model="self" :radioList="isSelfData" label="体检者" class="isSelf">
      </v-radio>
    </div>
    <div class="page-hint assertive text-center">请如实填写以下信息，确保您的预约有效。</div>
    <div class="m-box">

      <v-input v-model="present.callName" placeholder="请输入姓名" label="姓　名"></v-input>
      <v-input v-model="present.idCardNo" :placeholder="present.initIdCardNo || '请输入正确的身份证号'" label="身份证"
               :maxlength="18"></v-input>
      <v-radio v-model="present.sexCode" :radioList="sexData" label="性　别"></v-radio>
      <v-input v-model="present.age" placeholder="请输入年龄" label="年　龄" unit="岁"></v-input>
      <v-actionsheet v-model="present.marryStateCode" label="婚　姻" placeholder="请选择您的婚姻状况"
                     :dataList="actions"></v-actionsheet>
      <v-actionsheet v-model="present.folkId" label="民　族" placeholder="请选择您的民族" :dataList="folk"></v-actionsheet>
    </div>
    <div class="m-box">
      <v-input v-model="present.height" placeholder="请输入身高" label="身　高" unit="厘米(CM)"></v-input>
      <v-input v-model="present.weight" placeholder="请输入体重" label="体　重" unit="公斤(KG)"></v-input>
    </div>
    <div class="m-box" v-if="$route.params.source !=='personal'">
      <v-div v-model="sysCenterName" @clicked="changeSysCenter" :arrow="true" label="体检中心" placeholder="请选择体检中心">
      </v-div>
    </div>
    <m-button @click.native="toNext()">下一步</m-button>
    <!--<hint :showModal="popState" :showTxt="nextTxt" :btnList="['忽略信息','完善信息']" @btnClick="hanlder"></hint>-->
    <!--<hint :showModal="productSelect" :showTxt="productSexcode" :btnList="['重新选择套餐','修改信息']" @btnClick="toEdit"></hint>-->
    <hint :showModal="showHint" :showTxt="hintMsg.title" :btnList="hintMsg.btn" @btnClick="hanlder"></hint>
    <hint :showModal="showCenterUser" showTxt="请先在医院挂号收费窗口办理实名就诊卡或官微注册电子就诊卡。" :btnList="['取消','确定']" @btnClick="hanlderUser"></hint>
    <sys-center-list mode="projectSelectOpt" :hasRouter="false" :showModal.sync="showPopup"
                     v-if="$route.params.source === 'custom'"
                     @maskClick="closeSysCenterList" @itemClick="itemClick"></sys-center-list>
  </div>
</template>

<script>
import MButton from '../../components/common/button/m-button'
import Dict from '../../assets/scripts/dict/dict'
import {
  GET_USER,
  UPDATE_USER,
  BEFORE_QUESTION,
  BASE_PROJECT_LIST,
  VALIDATE_ORDER,
  SYSTEM_CENTER_APPOINTMENT_CONFIG
} from '@/assets/scripts/api'
import axios from 'axios'
import Vue from 'vue'
import { VRadio, VInput, VActionsheet, hint, sysCenterList, VDiv } from '@/components/common'
import { mapGetters, mapState } from 'vuex'
import { Loading, ToastMessage, IDCardMsg } from '@/assets/scripts/helper'
import validation from '@/assets/scripts/validation'
import { Location } from '../../assets/scripts/helper/index'

Vue.use(validation)

export default {
  components: {MButton, Loading, VRadio, VInput, VActionsheet, hint, sysCenterList, VDiv},
  data () {
    return {
      showHint: false,
      projectSelectOpt: true,
      showCenterUser: false,
      hintMsg: {
        title: '',
        btn: []
      },
      showPopup: false,
      msgList: {
        productSexcode: {
          title: '您选择的套餐适用性别与您所选择的体检者性别不一致，请核实体检者性别、套餐适用性别！',
          btn: ['重新选择套餐', '修改信息'],
          name: 'sexCode'
        },
        nextTxt: {
          title: '身高和体重信息是筛查您潜在的健康风险，定制符合您实际需要的专属体检方案，最大限度地避免遗漏检查的重要依据，强烈建议完善该信息！',
          btn: ['忽略信息', '完善信息'],
          name: 'userMsg'
        },
        orderErr: {title: '', btn: ['查看订单', '确定'], name: 'order'},
        showConfig: {title: '该体检中心暂未开放自选项目预约，是否继续选择其他体检中心预约', btn: ['查看套餐', '确定'], name: 'config'}
      },
      folk: Dict.user_folk, // 民族
      sexData: [
        {name: '男', code: 'male'},
        {name: '女', code: 'female'}
      ],
      actions: [
        {name: '已婚(含同居)', id: 'married'},
        {name: '未婚', id: 'unmarried'}
      ],
      self: '1', // 1 自己 0其他人
      closeModel: false, // 是够关闭过提示完善信息  true关闭 关闭以后直接可以进行提交
      othersData: {}, // 保存代他人数据
      selfData: {}, // 保存自己数据
      present: {
        callName: '',
        marryStateCode: '',
        idCardNo: '',
        sexCode: '',
        age: '',
        folkId: '',
        height: null,
        weight: null
      }
    }
  },
  validation: {
    data: {
      'present.callName': {
        required: true,
        RegExp: '^([\\u4e00-\\u9fa5]{2,10}|[a-zA-Z]{2,10})$|^(?=.*[\\u4e00-\\u9fa5])(?=.*\\d)[\\u4e00-\\u9fa5\\d]{2,10}$'
      },
      'present.idCardNo': {
        if: function (dataValidations) {
          if ((this.self === '1' && this.present.initIdCardNo === '') || this.self === '0') {
            dataValidations.required = true
          } else if (dataValidations.required) {
            dataValidations.required = false
          }
        },
        IDCard: true,
        RegExp: '^([1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx])$|^([1−9]\\d5\\d2((0[1−9])|(10|11|12))(([0−2][1−9])|10|20|30|31)\\d2[0−9Xx])$'
      },
      'present.sexCode': {
        required: true
      },
      'present.age': {
        required: true,
        between: {
          min: 16,
          max: 85
        }
      },
      'present.marryStateCode': {
        required: true
      },
      'present.folkId': {
        required: true
      },
      'present.height': {
        between: {
          min: 100,
          max: 220
        },
        RegExp: '^[0-9]{3}$'
      },
      'present.weight': {
        between: {
          min: 30,
          max: 150
        },
        RegExp: '^[0-9]{2,3}(\.[0-9]{1})?$'
      }
    },
    msg: {
      'present.callName': {
        required: '请输入体检者姓名',
        RegExp: '必须为全中文或全英文'
      },
      'present.age': {
        between: '年龄必须在16-85范围内！'
      },
      'present.height': {
        between: '身高需要在100-220范围内！',
        RegExp: '请输入整数值'
      },
      'present.weight': {
        between: '体重需要在30-150范围内！',
        RegExp: '请输入整数或小于1位的小数值'
      }

    }
  },
  async created () {
    Loading.show()
    let han = this.folk[0]
    let folkObj = {
      folkId: han.id,
      folkName: han.name,
      folkCode: han.code
    }
    this.othersData = Object.assign({}, this.present, folkObj)
    let {data} = await this.$axios.get(GET_USER)
    this.selfData = data.data
    //处理数据展示
    if (/^[0-9]+$/.test(this.selfData.callName)) {
      this.selfData.callName = ''
    }
    if (!this.selfData.folkId || !this.selfData.folkName || !this.selfData.folkCode) {
      Object.assign(this.selfData, folkObj)
    }
    let {callName, idCardNo} = this.selfData
    this.selfData.initName = callName
    this.selfData.initIdCardNo = idCardNo
    this.selfData.idCardNo = ''
    this.present = Object.assign({}, this.selfData)
    this.present.height = this.present.height ? this.present.height : ''
    this.present.weight = this.present.weight ? this.present.weight : ''
    if (Object.keys(this.fillUserInfo).length > 0) {
      this.self = this.fillUserInfo.self || this.fillUserInfo.isSelf || '1'
      Object.assign(this.othersData, this.fillUserInfo)
    }
    this.$nextTick(() => {
      this.$validation.reset()
    })
    Loading.close()
  },
  mounted () {

  },
  methods: {
    hanlderUser (index) {
      this.showCenterUser = false
      if (index) { Location('https://ali.whxh.com.cn/views/p187/index.html?auth=1&platformSource=1&platformId=187#/enrollment/enrollment') }
    },
    async itemClick (e) {
      let params = {
        sysCenterId: e.id,
        _BIZCODE: '0001'
      }
      //
      //           params.packageId = this.$route.params.source
      //         }
      if (this.$route.params.source !== 'custom' && this.$route.params.source !== 'personal') { await this.$store.dispatch('center/loadSysCenterAppointmentInfo', this.$route.params.source) }
      //        let {data} = await this.$axios.get(SYSTEM_CENTER_APPOINTMENT_CONFIG, {
      //          params: params
      //        })
      //        this.$nextTick(function() {
      let data = this.$store.state.center.sysCenter
      if (data.projectSelectOpt === 0 && this.$route.params.source === 'custom') {
        this.projectSelectOpt = false
        this.hintMsg = this.msgList.showConfig
        this.showHint = true
      } else {
        this.projectSelectOpt = true
      }
    },
    async toCustomAppointmentConfirm () {
      Loading.show()
      let params = {
        sexCode: this.present.sexCode,
        marryStateCode: this.present.marryStateCode,
        age: this.present.age,
        sysCenterId: this.$store.state.center.sysCenter.id
      }
      await this.$store.dispatch('project/loadProjectData', Object.assign({aqInstanceId: ''}, params))
      let {data} = await axios.get(BASE_PROJECT_LIST(params))
      let basePackagePros = data.map(project => {
        project.projectId = project.id
        return project
      })

      this.$store.commit('project/initCustomizeProjectList', {
        basePackagePros,
        rulePackagePros: [],
        recommendPros: []
      })
      await this.$store.dispatch('project/loadProjectTree')
      await this.$store.commit('project/initProjectClassList')
      this.$store.commit('project/setCheckedMaterialProjectList')
      Loading.close()
    },
    closeSysCenterList () {
      if (this.$store.state.sid === '00-0' && !this.$store.state.center.sysCenter.name) {
        ToastMessage('请先选择一个体检中心')
      } else {
        this.showPopup = false
      }
    },
    changeSysCenter () {
      this.showPopup = true
    },
    async setFillUserData () {
      let params = {isSelf: this.self}
      if (this.self === '0') {
        params.mobilePhone = ''
      }
      this.$store.commit('user/setFillUserInfo', Object.assign({}, this.present, params))
    },
    async toNext () {
      let errObj = this.$validation.validAll()
      if (this.$store.state.center.sysCenter.id) await this.itemClick({id: this.$store.state.center.sysCenter.id})
      if (!this.projectSelectOpt) { return false }
      if (!errObj && this.projectSelectOpt) {
        //          if (this.$store.state.sid === '00-05') {
        //            let {data} = await this.$axios.get('/hospital/checkrealname', {
        //              params: {
        //                zjlx: '01',
        //                pat_name: this.present.callName,
        //                zjhm: this.present.idCardNo
        //              }
        //            })
        //            if (data.code === -1) {
        //              this.showCenterUser = true
        //              return
        //            }
        //          }

        if (this.$route.params.source !== 'personal' && this.$route.params.source !== 'custom' && this.present.sexCode !== this.$store.state.project.product.sexCode && this.$store.state.project.product.sexCode !== 'common') {
          this.showHint = true
          this.hintMsg = this.msgList.productSexcode
        } else if ((this.present.height || this.present.weight) || this.closeModel || this.$route.params.source === 'custom') {
          if (this.present.idCardNo) this.present.idCardNo = this.present.idCardNo.toUpperCase()
          await this.setFillUserData()
          if (this.self === '1') await this.updateUser()
          if (this.$route.params.source === 'custom') {
            if (this.hasSysCenter) {
              if ((!this.present.height || !this.present.weight) && !this.closeModel) {
                this.hintMsg = this.msgList.nextTxt
                this.showHint = true
                return true
              }
              await this.getValidate()
              if (this.hintMsg.name === 'order' && this.showHint) return false
              await this.toCustomAppointmentConfirm()
              // 进入自选项目界面
              this.$router.push({
                name: 'appointmentConfirm',
                params: {type: 'custom', id: 'custom'}
              })
            } else {
              this.showPopup = true
            }
          } else {
            this.$route.params.source !== 'personal' ? await this.fromProduct() : await this.fromPersonal()
          }
        } else {
          this.hintMsg = this.msgList.nextTxt
          this.showHint = true
        }
      }
    },
    async updateUser () {
      Loading.show()
      this.present._BIZCODE = '0004'
      this.present.sexFromId = this.present.sexCode
      this.present.ageFromId = this.present.age
      if (this.present.birthday !== undefined) delete (this.present.birthday)
      await axios.post(UPDATE_USER, this.present)
      this.$store.dispatch('user/replaceUserData')
      Loading.close()
    },
    async getValidate () {
      let data = await this.$axios.get(VALIDATE_ORDER, {
        params: {
          sysCenterId: this.$store.state.center.sysCenter.id,
          idCardNo: this.present.idCardNo
        }
      })
      if (data.error) {
        this.msgList.orderErr.title = data.error
        this.hintMsg = this.msgList.orderErr
        this.showHint = true
      }
    },
    async fromProduct () {
      await this.getValidate()
      if (this.hintMsg.name === 'order' && this.showHint) return false
      Loading.show()
      let params = {
        sexCode: this.present.sexCode,
        marryStateCode: this.present.marryStateCode,
        age: this.present.age,
        sysCenterId: this.$store.state.project.product.sysCenterId,
        aqInstanceId: '',
        packageId: this.$route.params.source
      }
      await this.$store.dispatch('project/loadProjectData', params)
      this.$store.commit('project/initPackageProjectList')
      await this.$store.dispatch('project/loadProjectTree')
      await this.$store.commit('project/initProjectClassList')
      this.$store.commit('project/setProductProjects')
      // 进入套餐自选项目界面
      this.$router.push({
        name: 'appointmentConfirm',
        params: {type: 'product', id: 'pd'}
      })
      Loading.close()
    },
    async fromPersonal () {
      Loading.show()
      let data = null
      if (this.self === '1' && this.$route.query.record !== '1') {
        data = await this.beforeQuestion()
      }
      let urlMsg = {}
      if (data !== null) {
        urlMsg = {
          name: 'questionDetails',
          params: {source: 'information', instanceId: data.instance.id}
        }
        //        this.$router.push()
      } else {
        urlMsg = {name: 'physicalQuestionnaire', params: {source: 'personal'}}
        //        this.$router.push({name: 'physicalQuestionnaire', params: {source: 'personal'}})
      }
      if (this.$route.query.result) {
        urlMsg.query = this.$route.query
      }
      this.$router.push(urlMsg)
      Loading.close()
    },
    async beforeQuestion () {
      let {data} = await this.$axios.get(BEFORE_QUESTION, {
        params: {
          type: 'x',
          //            sysCenterId: '',
          marriageCode: this.present.marryStateCode,
          name: this.present.callName,
          sexCode: this.present.sexCode
        }
      })
      return data.data
    },
    hanlder (index) {
      this.showHint = false

      if (index === 0) {
        if (this.hintMsg.name === 'config') {
          this.$router.push({name: 'productList', query: {sysCenterId: this.$store.state.center.sysCenter.id}})
        } else if (this.hintMsg.name === 'userMsg') {
          this.closeModel = true
          this.toNext()
        } else if (this.hintMsg.name === 'order') {
          this.$router.push({name: 'order', query: {type: '1'}})
        } else {
          this.$router.go(-2)
        }
      } else if (index !== 'mask' && this.hintMsg.name === 'config') {
        this.showPopup = true
      }
    }
  },
  computed: {
    ...mapGetters({
      hasSysCenter: 'center/hasSysCenter'
    }),
    fillUserInfo () {
      return this.$store.state.user.fillUserInfo
    },
    ...mapState({
      sid: state => state.sid
    }),
    sysCenterName () {
      return this.$store.state.center.sysCenter.name || ''
    },
    isSelfData () {
      let name = '缺省'
      let selfData = this.selfData
      if (selfData && selfData.initName && selfData.initName.length >= 6) {
        name = selfData.initName.substring(0, 3) + '...' + selfData.initName.substring(selfData.initName.length - 2, selfData.initName.length)
      } else if (selfData.initName) {
        name = selfData.initName
      }
      return [{name: `自己 (${name})`, code: '1'}, {name: '代他人', code: '0'}]
    }
  },
  watch: {
    'present.idCardNo' (newValue, oldValue) {
      this.$nextTick(obj => {
        if (newValue && !this.$validation.error('present.idCardNo')) {
          let msg = IDCardMsg(this.present.idCardNo)
          this.present.age = msg.age
          this.present.sexCode = msg.sexCode
        }
      })
    },
    self () {
      if (this.self === '1') {
        this.present = this.selfData
      } else {
        this.present = this.othersData
      }
      this.$nextTick(() => {
        this.$validation.reset()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
  .m-page {
    padding-bottom: 60px;
  }

  .page-hint {
    padding: 0 0 5px 10px;
  }

  .m-box {
    margin-bottom: 10px;
    background-color: #ffffff;
  }

    .m-pop {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background-color: rgba(7, 17, 27, 0.7);
      .m-pop-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 313px;
        height: 290px;
        border-radius: 15px;
        font-size: 0;
        background-color: #ffffff;
        > img {
          width: 100%;
          height: 98px;
          border-radius: 15px 15px 0 0;
        }
        .m-pop-cont {
          position: relative;
          width: 100%;
          height: 140px;
          padding: 20px;
          text-align: center;
          .m-pop-img {
            position: absolute;
            top: -30%;
            left: 50%;
            width: 88px;
            height: 88px;
            transform: translateX(-50%);
          }
          h4 {
            font-weight: bold;
            line-height: 44px;
            font-size: 18px;
            color: #333333;
          }
          p {
            line-height: 24px;
            font-size: 14px;
            color: #666666;
          }
          .m-pop-title {
            line-height: 44px;
            padding: 30px 0 10px;
            font-size: 24px;
            font-weight: bold;
            color: $assertive;
          }
          .m-pop-text {
            line-height: 24px;
            font-size: 14px;
            text-align: left;
            color: #666666;
          }
        }
        p {
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 16px;
          border-top: 1px solid #f5f5f5;
          color: $assertive;
        }
        .m-pop-foot {
          padding-top: 80px;
          text-align: center;
          .btn {
            height: 30px;
            line-height: 28px;
            padding: 0 24px;
            font-size: 14px;
            border-radius: 15px;
            &:first-child {
              margin-right: 20px;
              background-color: #ffffff;
              border: 1px solid $assertive;
              color: $assertive;
            }
            &:last-child {
              background-color: $assertive;
              border: 1px solid $assertive;
              color: #ffffff;
            }
          }
        }
      }
    }

    .agree {
      font-size: 14px;
      margin-top: 10px;
      padding: 0 15px;

    }

    .isSelf /deep/ .m-rads .m-rad:first-child {
      flex: 0 0 65% !important;
    }

  .centerName /deep/ {
    .item-right {
      flex: 0 0 65%;
      .m-sub {
        text-overflow: ellipsis;
        overflow: hidden;
        /*white-space: nowrap;*/
        width: 100%;
      }
    }
  }

  .m-confirm {
    position: fixed;
    bottom: 0px;
    margin: 0;
    padding: 5px 25px;
    /*background: ;*/
    width: 10rem;
    button {
      width: 100%;
    }
  }
</style>
